"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseRcCalendar = _interopRequireDefault(require("nicbase-rc-calendar"));

var _Picker = _interopRequireDefault(require("nicbase-rc-calendar/lib/Picker"));

var _Panel = _interopRequireDefault(require("nicbase-rc-time-picker/lib/Panel"));

var _nicbaseTranslation = require("nicbase-translation");

var _locales = _interopRequireDefault(require("../locales"));

require("nicbase-rc-calendar/assets/index.css");

require("nicbase-rc-time-picker/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DateTimePicker = function DateTimePicker(_ref) {
  var timezone = _ref.timezone,
      locale = _ref.locale,
      inputLabel = _ref.inputLabel,
      hideLabel = _ref.hideLabel,
      inputClassName = _ref.inputClassName,
      selectedDate = _ref.selectedDate,
      defaultOpenValue = _ref.defaultOpenValue,
      onChange = _ref.onChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      enableTime = _ref.enableTime,
      enabledDate = _ref.enabledDate,
      error = _ref.error,
      disabled = _ref.disabled,
      isFilterFlyOut = _ref.isFilterFlyOut;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(selectedDate ? _momentTimezone["default"].tz((0, _momentTimezone["default"])(selectedDate), timezone).locale(locale) : null),
      _useState4 = _slicedToArray(_useState3, 2),
      selection = _useState4[0],
      setSelection = _useState4[1];

  var _useState5 = (0, _react.useState)(selectedDate ? _momentTimezone["default"].tz((0, _momentTimezone["default"])(selectedDate), timezone).locale(locale) : null),
      _useState6 = _slicedToArray(_useState5, 2),
      visibleDate = _useState6[0],
      setVisibleDate = _useState6[1]; // handle change of selectedDate in props


  var prevSelectedDate = (0, _hooks.usePrevious)(selectedDate);
  (0, _hooks.useDidUpdate)(function () {
    if (!selectedDate && !selection) {
      return;
    }

    if (prevSelectedDate !== selectedDate && (!selection || selection && !selection.isSame(selectedDate))) {
      var newDate = selectedDate && _momentTimezone["default"].tz((0, _momentTimezone["default"])(selectedDate), timezone).locale(locale);

      setSelection(newDate);
      setVisibleDate(newDate);
    }
  }, [locale, prevSelectedDate, selectedDate, selection, timezone]); // handle selection change

  var prevSelection = (0, _hooks.usePrevious)(selection);
  (0, _hooks.useDidUpdate)(function () {
    if (selection === visibleDate) {
      if (prevSelection !== selection) {
        onChange((selection === null || selection === void 0 ? void 0 : selection.toDate()) || null);
        setOpen(false);
      }
    } else if (!open) {
      setVisibleDate(selection);
    }
  }, [onChange, open, prevSelection, selection, visibleDate]);

  var handleChange = function handleChange(newSelection) {
    setVisibleDate(newSelection);

    if (!enableTime && newSelection !== null) {
      setSelection(newSelection || (0, _momentTimezone["default"])(new Date()).locale(locale));
    }

    if (newSelection === null) {
      setSelection(null);
    }
  };

  var isDateDisabled = function isDateDisabled(dateToCheck) {
    if (enabledDate) {
      return !enabledDate({
        minDate: minDate,
        maxDate: maxDate,
        timezone: timezone,
        selectedDate: visibleDate === null || visibleDate === void 0 ? void 0 : visibleDate.toDate(),
        dateToCheck: dateToCheck === null || dateToCheck === void 0 ? void 0 : dateToCheck.toDate()
      });
    }

    if (minDate && dateToCheck < _momentTimezone["default"].tz((0, _momentTimezone["default"])(minDate), timezone) || maxDate && dateToCheck > _momentTimezone["default"].tz((0, _momentTimezone["default"])(maxDate), timezone)) {
      return true;
    }

    return false;
  };

  var format = enableTime ? 'L LT' : 'L';
  var today = (0, _momentTimezone["default"])(new Date()).locale(locale).format(format);
  return /*#__PURE__*/_react["default"].createElement(_Picker["default"], {
    disabled: disabled,
    onChange: handleChange,
    open: open,
    onOpenChange: setOpen,
    value: visibleDate && visibleDate.locale(locale).tz(timezone),
    defaultOpenValue: visibleDate,
    calendar: /*#__PURE__*/_react["default"].createElement(_nicbaseRcCalendar["default"], {
      defaultValue: visibleDate,
      locale: _locales["default"][locale],
      momentLocale: locale,
      onOk: function onOk(newSelection) {
        return setSelection(newSelection || (0, _momentTimezone["default"])(new Date()).locale(locale));
      },
      dateInputPlaceholder: visibleDate || today,
      showToday: false,
      disabledDate: isDateDisabled,
      format: format,
      timePicker: enableTime ? /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        showSecond: false,
        defaultOpenValue: defaultOpenValue
      }) : null
    })
  }, function (_ref2) {
    var value = _ref2.value;
    return !isFilterFlyOut ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "block relative"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiInput, {
      className: inputClassName,
      label: inputLabel,
      hideLabel: hideLabel,
      disabled: disabled,
      error: error,
      readOnly: true,
      value: value && (0, _momentTimezone["default"])(value).locale(locale).format(format) || ''
    }), value && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "filters.resetFilterInput"
    }, function (message) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        title: message,
        className: "absolute right-0 top-1/2 cursor-pointer transform -translate-x-1 -translate-y-1/2 transition duration-400 ease-in-out hover:scale-120",
        onClick: function onClick(e) {
          e.stopPropagation();
          handleChange(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Clear, {
        className: "fill-primary w-4 h-4"
      }));
    })) : /*#__PURE__*/_react["default"].createElement("label", {
      className: "relative flex flex-1 items-center text-primary"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "bg-gray-200 py-1 px-6 rounded outline-none flex-1 border-solid border-transparent border-b-2 focus:border-primary transition-colors duration-300",
      value: value && (0, _momentTimezone["default"])(value).locale(locale).format(format) || ''
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "sr-only"
    }, inputLabel), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
      className: "absolute fill-primary h-6 w-6 px-1"
    }), value && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "filters.resetFilterInput"
    }, function (title) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "absolute right-0 cursor-pointer transform -translate-x-1/4",
        title: title,
        onClick: function onClick(e) {
          e.stopPropagation();
          handleChange(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Clear, {
        className: "h-5 w-5 fill-primary"
      }));
    }));
  });
};

var noop = function noop() {};

exports.noop = noop;
DateTimePicker.propTypes = {
  isFilterFlyOut: _propTypes["default"].bool,
  timezone: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  enableTime: _propTypes["default"].bool,
  minDate: _propTypes["default"].string,
  maxDate: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  inputLabel: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  error: _propTypes["default"].node,
  enabledDate: _propTypes["default"].func,
  defaultOpenValue: _propTypes["default"].instanceOf(Object),
  selectedDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number]),
  inputClassName: _propTypes["default"].string
};
DateTimePicker.defaultProps = {
  inputClassName: '',
  isFilterFlyOut: false,
  defaultOpenValue: undefined,
  selectedDate: null,
  enabledDate: undefined,
  timezone: 'Europe/Berlin',
  locale: 'en-GB',
  inputLabel: null,
  hideLabel: false,
  error: '',
  disabled: false,
  enableTime: false,
  minDate: undefined,
  maxDate: undefined,
  onChange: noop
};
var _default = DateTimePicker;
exports["default"] = _default;